export const getMyPageMessages = () => {
    const MYPAGE_MENU = {
        DASHBOARD: [
            { message: 'Dashboard', language: 'English' },
            { message: 'ダッシュボード', language: 'Japanese' },
            { message: 'Dashboard', language: 'Traditional' },
            { message: 'Dashboard', language: 'Simplified' },
        ],
        API_MANAGEMENT: [
            { message: 'API Management', language: 'English' },
            { message: 'API管理', language: 'Japanese' },
            { message: 'API管理', language: 'Traditional' },
            { message: 'API管理', language: 'Simplified' },
        ],
        MYPAGE_MESSAGE: [
            { message: 'Message', language: 'English' },
            { message: 'メッセージ', language: 'Japanese' },
            { message: '通知訊息', language: 'Traditional' },
            { message: '通知讯息', language: 'Simplified' },
        ],
    };
    const MYPAGE_API_MANAGEMENT = {
        TITLE_API_ACCESS_TOKEN_RESULT: [
            { message: 'Result of API access token creation', language: 'English' },
            { message: 'APIアクセストークン作成結果', language: 'Japanese' },
            { message: 'API Access Token生成結果', language: 'Traditional' },
            { message: 'API Access Token生成結果', language: 'Simplified' },
        ],
        INPUT_LABEL_LABEL_NAME: [
            { message: 'API lable name', language: 'English' },
            { message: 'APIラベル名', language: 'Japanese' },
            { message: 'API標籤名稱', language: 'Traditional' },
            { message: 'API标签名称', language: 'Simplified' },
        ],
        INPUT_LABEL_ROLES: [
            { message: 'Restriction', language: 'English' },
            { message: '権限', language: 'Japanese' },
            { message: '權限', language: 'Traditional' },
            { message: '权限', language: 'Simplified' },
        ],
        INPUT_LABEL_ACCESS_KEY: [
            { message: 'API access key', language: 'English' },
            { message: 'APIアクセスキー', language: 'Japanese' },
            { message: 'APIアクセスキー', language: 'Traditional' },
            { message: 'APIアクセスキー', language: 'Simplified' },
        ],
        INPUT_LABEL_ACCESS_SECRET: [
            { message: 'API access secret', language: 'English' },
            { message: 'APIアクセスシークレット', language: 'Japanese' },
            { message: 'APIアクセスシークレット', language: 'Traditional' },
            { message: 'APIアクセスシークレット', language: 'Simplified' },
        ],
        BTN_APPLY: [
            { message: 'Apply', language: 'English' },
            { message: '申請する', language: 'Japanese' },
            { message: '申請', language: 'Traditional' },
            { message: '申请', language: 'Simplified' },
        ],
        BTN_CREATE_API: [
            { message: 'Create API', language: 'English' },
            { message: 'API作成', language: 'Japanese' },
            { message: 'API生成', language: 'Traditional' },
            { message: 'API生成', language: 'Simplified' },
        ],
        BTN_EDIT_API: [
            { message: 'Edit', language: 'English' },
            { message: '編集', language: 'Japanese' },
            { message: '編輯', language: 'Traditional' },
            { message: '编辑', language: 'Simplified' },
        ],
        BTN_DELETE_API: [
            { message: 'Delete', language: 'English' },
            { message: '削除', language: 'Japanese' },
            { message: '刪除', language: 'Traditional' },
            { message: '删除', language: 'Simplified' },
        ],
        BTN_DELETE_ALL_API: [
            { message: 'Delete All API', language: 'English' },
            { message: 'API一括削除', language: 'Japanese' },
            { message: '刪除所有API', language: 'Traditional' },
            { message: '删除所有API', language: 'Simplified' },
        ],
        BTN_CLOSE: [
            { message: 'Close', language: 'English' },
            { message: '閉じる', language: 'Japanese' },
            { message: '關閉', language: 'Traditional' },
            { message: '关闭', language: 'Simplified' },
        ],
        BTN_SAVE: [
            { message: 'Save', language: 'English' },
            { message: '保存する', language: 'Japanese' },
            { message: '儲存', language: 'Traditional' },
            { message: '储存', language: 'Simplified' },
        ],
        LINK_BACK_TO_LIST: [
            { message: 'Back to list', language: 'English' },
            { message: '一覧へ戻る', language: 'Japanese' },
            { message: '返回一覽畫面', language: 'Traditional' },
            { message: '返回一览画面', language: 'Simplified' },
        ],
        LINK_DOWNLOAD: [
            { message: 'Download', language: 'English' },
            { message: 'ダウンロード', language: 'Japanese' },
            { message: '下載', language: 'Traditional' },
            { message: '下载', language: 'Simplified' },
        ],
        LINK_ABOUT_API: [
            { message: 'About API', language: 'English' },
            { message: 'APIについて', language: 'Japanese' },
            { message: '關於API', language: 'Traditional' },
            { message: '关于API', language: 'Simplified' },
        ],
        SUCCESS_EXTEND_API: [
            { message: 'API access token was Extended', language: 'English' },
            { message: 'APIアクセストークンを延長しました', language: 'Japanese' },
            { message: '已延長API Access Token', language: 'Traditional' },
            { message: '已延长API Access Token', language: 'Simplified' },
        ],
        SUCCESS_DELETE_API: [
            { message: 'Removed API access token', language: 'English' },
            { message: 'APIアクセストークンを削除しました', language: 'Japanese' },
            { message: '刪除了API Access Token', language: 'Traditional' },
            { message: '删除了API Access Token', language: 'Simplified' },
        ],
        ALERT_KYC: [
            { message: 'KYC submission and approval is required to apply for User API.', language: 'English' },
            { message: 'ユーザーAPIを申請するには、KYCの提出・承認が必要となります。', language: 'Japanese' },
            {
                message: '申請用戶API, 請先確認已通過KYC認證',
                language: 'Traditional',
            },
            {
                message: '申请用户API, 请先确认已通过KYC认证',
                language: 'Simplified',
            },
        ],
        ALERT_WAITING: [
            {
                message: 'We have received your application for the User API. Please wait until the confirmation is completed.',
                language: 'English',
            },
            { message: 'ユーザーAPIの申請を受け付けました。運営の確認が完了するまでお待ちください。', language: 'Japanese' },
            {
                message: '已接受用戶API申請。在營運方確認完成前請稍候。',
                language: 'Traditional',
            },
            {
                message: '已接受用户API申请。在营运方确认完成前请稍候。',
                language: 'Simplified',
            },
        ],
        ALERT_REJECT: [
            { message: 'User API is not available.', language: 'English' },
            { message: 'ユーザーAPIをご利用することができません。', language: 'Japanese' },
            { message: '無法使用用戶API', language: 'Traditional' },
            { message: '无法使用用户API', language: 'Simplified' },
        ],
        CONFIRM_DELETE: [
            { message: 'Are you sure you want to delete "{{label}}"?', language: 'English' },
            { message: '「{{label}}」を削除してもよろしいですか？', language: 'Japanese' },
            { message: '確定刪除「{{label}}」嗎', language: 'Traditional' },
            { message: '确定删除「{{label}}」吗', language: 'Simplified' },
        ],
        CONFIRM_DELETE_ALL: [
            { message: 'Are you sure you want to delete all API tokens?', language: 'English' },
            { message: 'APIトークンを一括削除してもよろしいですか？', language: 'Japanese' },
            { message: '確定刪除所有API TOKEN嗎', language: 'Traditional' },
            { message: '确定删除所有API TOKEN吗', language: 'Simplified' },
        ],
        TEXT_EXPIRATION_PERIOD: [
            { message: 'Expiration period', language: 'English' },
            { message: '有効期限', language: 'Japanese' },
            { message: '有效期限', language: 'Traditional' },
            { message: '有效期限', language: 'Simplified' },
        ],
        TEXT_EXPIRED: [
            { message: 'Expired', language: 'English' },
            { message: '有効期限れ', language: 'Japanese' },
            { message: '有效期限已過', language: 'Traditional' },
            { message: '有效期限已过', language: 'Simplified' },
        ],
    };
    const MYPAGE_MESSAGE = {
        ALERT_NOT_FOUND_MESSAGE: [
            { message: 'No notification message', language: 'English' },
            { message: '通知メッセージはありません', language: 'Japanese' },
            { message: '無通知訊息', language: 'Traditional' },
            { message: '无通知讯息', language: 'Simplified' },
        ],
        BTN_DELETE: [
            { message: 'Delete', language: 'English' },
            { message: '削除', language: 'Japanese' },
            { message: '刪除', language: 'Traditional' },
            { message: '删除', language: 'Simplified' },
        ],
        CONFIRM_DELETE: [
            { message: 'Are you sure you want to delete the message?', language: 'English' },
            { message: 'メッセージを削除してもよろしいですか？', language: 'Japanese' },
            { message: '確定刪除訊息嗎？', language: 'Traditional' },
            { message: '确定删除讯息吗？', language: 'Simplified' },
        ],
        LINK_MORE: [
            { message: 'Read more', language: 'English' },
            { message: 'もっと見る', language: 'Japanese' },
            { message: '更多', language: 'Traditional' },
            { message: '更多', language: 'Simplified' },
        ],
        LINK_READ_ALL: [
            { message: 'Mark all messages as read', language: 'English' },
            { message: '全てのメッセージを既読にする', language: 'Japanese' },
            { message: '全部已讀', language: 'Traditional' },
            { message: '全部已读', language: 'Simplified' },
        ],
        LINK_READ: [
            { message: 'Mark messages as read', language: 'English' },
            { message: 'メッセージを既読にする', language: 'Japanese' },
            { message: '已讀', language: 'Traditional' },
            { message: '已读', language: 'Simplified' },
        ],
        SUCCESS_DELETE_API: [
            { message: 'Message deleted', language: 'English' },
            { message: 'メッセージを削除しました', language: 'Japanese' },
            { message: '已刪除訊息', language: 'Traditional' },
            { message: '已删除讯息', language: 'Simplified' },
        ],
        SUCCESS_READ_ALL_API: [
            { message: 'All messages have been read', language: 'English' },
            { message: '全てのメッセージを既読に変更しました', language: 'Japanese' },
            { message: '已變更所有訊息為已讀', language: 'Traditional' },
            { message: '已变更所有讯息为已读', language: 'Simplified' },
        ],
    };
    return {
        MYPAGE_MENU,
        MYPAGE_API_MANAGEMENT,
        MYPAGE_MESSAGE,
    };
};
